import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--gray-200);
  padding: var(--space-4) 0;
  transition: all var(--transition-normal);

  .ant-row-space-between {
    align-items: center;
    justify-content: space-between;
  }

  @media (max-width: 768px) {
    padding: var(--space-3) 0;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  transition: transform var(--transition-normal);
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:focus {
    outline: 2px solid var(--accent-color);
    outline-offset: 4px;
    border-radius: var(--radius-md);
  }
`;

export const NavLink = styled("div")`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const CustomNavLink = styled("div")`
  display: inline-flex;
  align-items: center;
  min-width: 120px;
  padding: 0 var(--space-2);

  @media (max-width: 1024px) {
    min-width: 100px;
  }

  @media (max-width: 768px) {
    min-width: auto;
    padding: 0 var(--space-1);
  }
`;

export const Burger = styled("div")`
  display: none;
  cursor: pointer;
  padding: var(--space-2);
  border-radius: var(--radius-md);
  transition: all var(--transition-normal);
  
  &:hover {
    background-color: var(--gray-100);
  }
  
  &:focus {
    outline: 2px solid var(--accent-color);
    outline-offset: 2px;
  }

  @media (max-width: 1024px) {
    display: block;
  }

  svg {
    fill: var(--primary-color);
    width: 24px;
    height: 24px;
  }
`;

export const NotHidden = styled("div")`
  display: flex;
  align-items: center;
  gap: var(--space-2);

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Menu = styled("h2")`
  font-size: var(--text-2xl);
  font-weight: 700;
  color: var(--primary-color);
  margin: 0;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  position: relative;
  font-size: var(--text-base);
  font-weight: 500;
  color: var(--gray-700);
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  transition: all var(--transition-normal);
  cursor: pointer;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    background-color: var(--primary-color);
    transition: all var(--transition-normal);
    transform: translateX(-50%);
  }
  
  &:hover {
    color: var(--primary-color);
    background-color: var(--gray-50);
    transform: translateY(-1px);
    
    &::after {
      width: 80%;
    }
  }
  
  &:focus {
    outline: 2px solid var(--accent-color);
    outline-offset: 2px;
  }

  @media (max-width: 1024px) {
    width: 100%;
    text-align: left;
    padding: var(--space-4) var(--space-6);
    margin: var(--space-1) 0;
    border-radius: var(--radius-lg);
    
    &::after {
      display: none;
    }
    
    &:hover {
      background-color: var(--primary-color);
      color: white;
      transform: translateX(4px);
    }
  }
`;

export const Label = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: var(--gray-600);
  margin-bottom: var(--space-6);
  padding-bottom: var(--space-4);
  border-bottom: 1px solid var(--gray-200);
  cursor: pointer;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 24px;
  color: var(--gray-600);
  transition: transform var(--transition-normal);
  
  &:hover {
    transform: rotate(90deg);
  }
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all var(--transition-normal);
  display: flex;
  align-items: center;
  gap: var(--space-2);
  
  /* Remove the wavy underline effect for cleaner look */
  &:hover,
  &:active,
  &:focus {
    color: inherit;
  }
`;

// New component for better button styling
export const ContactButton = styled("button")`
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%);
  color: white;
  border: none;
  padding: var(--space-3) var(--space-6);
  border-radius: var(--radius-lg);
  font-weight: 600;
  font-size: var(--text-base);
  cursor: pointer;
  transition: all var(--transition-normal);
  box-shadow: var(--shadow-sm);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-lg);
    background: linear-gradient(135deg, var(--primary-light) 0%, var(--primary-color) 100%);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:focus {
    outline: 2px solid var(--accent-color);
    outline-offset: 2px;
  }

  @media (max-width: 1024px) {
    width: 100%;
    margin-top: var(--space-4);
    padding: var(--space-4) var(--space-6);
  }
`;

// Removed login dropdown styling - authentication no longer needed

// Removed login dropdown item styling - authentication no longer needed
